import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCommunity } from "../../api/communities/communities.api";
import { Community, Communities } from "../../api/communities/types";


export const useUpdateCommunity = (divCode: string) => {
     const queryClient = useQueryClient();
     return useMutation<Community, Error, Partial<Community>>({
          mutationFn: (updateCommunityData) => updateCommunity(updateCommunityData),
          onSuccess: (updatedCommunity) => {
               queryClient.setQueryData<Communities>(["communities", divCode], (oldData) => {
                    if (!oldData) return;
                    return { ...oldData, data: oldData.data.map((c) => c.id === updatedCommunity.id ? updatedCommunity : c) };
               });
          },
          onError: (error) => {
               console.error("Error updating community:", error);
          }
     });
};   